export const EMBEDDED_PLAYER_PORTAL_KEY = 'EMBEDDED_PLAYER_PORTAL_KEY';
export const EMBEDDED_PLAYER_WEB_ID = 'embedded-player';

type Orientation =
    | 'portrait'
    | 'portrait-upside-down'
    | 'landscape'
    | 'landscape-left'
    | 'landscape-right';

export const supportedOrientations: Orientation[] = [
    'landscape',
    'landscape-right',
    'landscape-left',
    'portrait',
];
